module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"plan":"Your plan","active":"Active","disabled":"Expired","payedUntil":"Paid until","left":"You have","currentPeriod":"Current period","subscriptionExpired":"Subscription has expired","change":"change"}}')
  delete Component.options._Ctor
}
